"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StripeInvoice = exports.StripeSubscription = exports.EStripeSubscriptionStatus = exports.StripePaymentIntent = exports.StripeCharge = void 0;
const index_1 = require("../index");
class StripeCharge extends index_1.Base {
    object = ""; // "charge",
    amount = null; // 2000,
    amount_captured = null; // 0,
    amount_refunded = null; // 0,
    balance_transaction = ''; // "txn_1032HU2eZvKYlo2CEPtcnUvl",
    billing_details = {};
    calculated_statement_descriptor = ''; // null,
    captured = null; // false,
    created = null; // 1609337356,
    currency = ''; // "usd",
    customer = ''; //,
    description = ''; // "My First Test Charge (created for API docs)",
    disputed = null; //false,
    failure_code = null; // null,
    failure_message = ''; // null,
    fraud_details = {}; //
    invoice = null; // null,
    livemode = null; // false,
    metadata = {}; // {},
    on_behalf_of = null; // null,
    status = ''; // succeeded, pending
    order = null; // null,
    outcome = null;
    paid = null; // true,
    payment_intent = null;
    payment_method = ''; // "pm_1I45MW2eZvKYlo2CO3ocmdTD",
    payment_method_details = {};
    receipt_email = ''; // null,
    receipt_number = null; //,
    receipt_url = ''; // "https://pay.stripe.com/receipts/acct_1032D82eZvKYlo2C/ch_1I45MW2eZvKYlo2CPdomT0G8/rcpt_IfQCGc8qRgwaUEbSMnVftQCHny8LFjv",
    refunded = null; // false,
    refunds = {};
    review = null;
    shipping = null;
    source_transfer = null;
    statement_descriptor = null;
    statement_descriptor_suffix = null;
    transfer_data = null;
    transfer_group = null;
    source = ''; // "tok_mastercard"
    constructor(data, olMap) {
        super('charges', null);
        (0, index_1.setObjectProperties)(this, data, olMap, StripeCharge);
    }
    get dateCreated() {
        return new Date(this.created * 1000);
    }
}
exports.StripeCharge = StripeCharge;
class StripePaymentIntent extends index_1.Base {
    id = '';
    parent = null;
    contact = null;
    account = null;
    metadata = {};
    object = '';
    amount = null;
    amount_capturable = null;
    amount_details = null;
    amount_received = null;
    application = '';
    application_fee_amount = null;
    automatic_payment_methods = null;
    canceled_at = null;
    cancellation_reason = '';
    capture_method = '';
    client_secret = '';
    confirmation_method = null;
    created = null;
    currency = '';
    customer = '';
    description = '';
    invoice = '';
    last_payment_error = null;
    latest_charge = '';
    livemode = null;
    next_action = null;
    on_behalf_of = '';
    payment_method = '';
    payment_method_options = null;
    payment_method_types = null;
    processing = null;
    receipt_email = '';
    review = '';
    setup_future_usage = null;
    shipping = null;
    statement_descriptor = '';
    statement_descriptor_suffix = '';
    status = null;
    transfer_data = null;
    transfer_group = '';
    // Added by me to store other important bits.
    payment_method_data = null;
    _m = ['status'];
    constructor(data, olMap) {
        super('payment_intents', null);
        (0, index_1.setObjectProperties)(this, data, olMap, StripePaymentIntent);
    }
    toString() {
        return `Intent: `;
    }
}
exports.StripePaymentIntent = StripePaymentIntent;
var EStripeSubscriptionStatus;
(function (EStripeSubscriptionStatus) {
    EStripeSubscriptionStatus["INCOMPLETE"] = "incomplete";
    EStripeSubscriptionStatus["INCOMPLETE_EXPIRED"] = "incomplete_expired";
    EStripeSubscriptionStatus["TRIALING"] = "trialing";
    EStripeSubscriptionStatus["ACTIVE"] = "active";
    EStripeSubscriptionStatus["PAST_DUE"] = "past_due";
    EStripeSubscriptionStatus["CANCELED"] = "canceled";
    EStripeSubscriptionStatus["UNPAID"] = "unpaid";
    EStripeSubscriptionStatus["NONE"] = "";
})(EStripeSubscriptionStatus || (exports.EStripeSubscriptionStatus = EStripeSubscriptionStatus = {}));
class StripeSubscription extends index_1.Base {
    id = '';
    object = '';
    application = '';
    application_fee_percent = null; // >= 0
    automatic_tax;
    billing_cycle_anchor = null;
    billing_thresholds = null;
    cancel_at = null;
    cancel_at_period_end = null;
    canceled_at = null;
    cancellation_details = null;
    collection_method = '';
    created = null; // 1687981713,
    currency = ''; // usd,
    current_period_end = null;
    current_period_start = null;
    customer = ''; // cus_OAPAwLXCDiEHYL
    days_until_due = null;
    default_payment_method = '';
    default_source = '';
    default_tax_rates = null;
    description = '';
    discount = null;
    ended_at = null;
    items = null;
    latest_invoice = null;
    livemode = null;
    metadata = {};
    pause_collection = null;
    pending_setup_intent = '';
    pending_update = null;
    schedule = null;
    start_date = null; // 1687981713,
    status = EStripeSubscriptionStatus.NONE;
    test_clock = '';
    transfer_data = null;
    trial_end = null; // 1688586513,
    trial_settings = null;
    trial_start = null;
    // Houses the reference to the payment
    stripe_invoices = new index_1.ChildArray();
    _m = ['status'];
    constructor(data, olMap) {
        super('stripe_subscriptions', null);
        (0, index_1.setObjectProperties)(this, data, olMap, StripeSubscription);
        this.convert();
    }
    toString() {
        return `Subscription: `;
    }
    async convert(opts) {
        if (this.start_date?.toString()?.length === 10) {
            this.start_date = this.start_date * 1000;
        }
    }
    async save(parent) {
        await this.convert();
        return super.save(parent);
    }
}
exports.StripeSubscription = StripeSubscription;
class StripeInvoice extends index_1.Base {
    invoice_id = '';
    name = '';
    email = '';
    order_id = '';
    id = ''; //in_1NviYhB0ZvawBcR6EhP4gfv6",
    object = ''; //invoice",
    account_country = ''; //US",
    account_name = ''; //Aerospace Technology Ventures, LLC",
    account_tax_ids = [];
    amount_due = null;
    amount_paid = null;
    amount_remaining = null;
    amount_shipping = null;
    application = '';
    application_fee_amount = null;
    attempt_count = null;
    attempted = null;
    auto_advance = null;
    automatic_tax = {};
    billing_reason = ''; //manual",
    charge = '';
    collection_method = ''; //charge_automatically",
    created = null;
    currency = ''; //usd",
    custom_fields = '';
    customer = ''; //cus_IxCIWkNTvmBMAQ",
    customer_address = '';
    customer_email = ''; //stuart@younghome.net",
    customer_name = ''; //Home Stu",
    customer_phone = '';
    customer_shipping = '';
    customer_tax_exempt = ''; //none",
    customer_tax_ids = [];
    default_payment_method = '';
    default_source = '';
    default_tax_rates = [];
    description = '';
    discount = '';
    discounts = [];
    due_date = '';
    effective_at = '';
    ending_balance = '';
    footer = '';
    from_invoice = '';
    hosted_invoice_url = '';
    invoice_pdf = '';
    last_finalization_error = '';
    latest_revision = '';
    lines = null;
    livemode = null;
    metadata;
    next_payment_attempt = '';
    number = '';
    on_behalf_of = '';
    paid = null;
    paid_out_of_band = null;
    payment_intent = null;
    payment_settings;
    period_end = null;
    period_start = null;
    post_payment_credit_notes_amount = null;
    pre_payment_credit_notes_amount = null;
    quote = '';
    receipt_number = '';
    rendering = '';
    shipping_cost = '';
    shipping_details = '';
    starting_balance = null;
    statement_descriptor = '';
    status = ''; //draft",
    status_transitions;
    subscription = '';
    subscription_details;
    subtotal = null;
    subtotal_excluding_tax = null;
    tax = '';
    test_clock = '';
    total = null;
    total_discount_amounts;
    total_excluding_tax = null;
    total_tax_amounts = [];
    transfer_data = '';
    webhooks_delivered_at = '';
    _m = ['status'];
    constructor(data, olMap) {
        super('stripe_invoices', null);
        (0, index_1.setObjectProperties)(this, data, olMap, StripeInvoice);
    }
    toString() {
        return `Invoice: `;
    }
}
exports.StripeInvoice = StripeInvoice;
index_1.olm.stripe_subscriptions = (ref, map) => {
    return new StripeSubscription(ref, map);
};
index_1.olm.stripe_invoices = (ref, map) => {
    return new StripeInvoice(ref, map);
};
